import { useState, useCallback } from 'react';

import licensesService from '../../services/ScaleoAdminApiServices/LicensesService';

const useCustomerWithLicenseData = () => {
  const [data, setData] = useState([]);

  const fetchCustomerWithLicenseData = useCallback(async () => {
    const allCustomersWithLicenses = await licensesService.getAllLicenses();

    if (allCustomersWithLicenses) {
      setData(allCustomersWithLicenses.data);
    }
  }, []);

  return {
    data,
    fetchCustomerWithLicenseData,
  };
};

export default useCustomerWithLicenseData;
